import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import BannerItem from '../../component/BannerItem/BannerItem'
import useWindowDimensions from '../../useWindowDimensions'
import banner from '../../images/aboutus/banner.png'
import create from '../../images/transit/create.png'
import australia from '../../images/destination2/australia-01.png'
import europe from '../../images/destination2/europe-01.png'
import sabah from '../../images/destination2/sabah & sarawak.png'
import united from '../../images/destination2/united kingdom-01.png'
import singapore from '../../images/destination2/singapore-01.png'
import WOW from 'wowjs'
import mobile834 from '../../images/transit/mobile834.png'
import './style.less'

import 'swiper/swiper-bundle.css'
import Swiper from 'swiper'

const Transit = (props) => {
	const { t } = useTranslation()
	const { height, width } = useWindowDimensions()

	const contentStyle = {
		//   height: 'auto',
		//   color: '#000',
		//   width:'100%',
		lineHeight: '160px',
		textAlign: 'center',
		background: '#364d79',
		background: 'red',
		padding: '5px 20px 40px 20px',
	}

	useEffect(() => {
		window.scroll(0, 0)
		document.title = 'Wyngs - Transit Kpi'
		new WOW.WOW({
			live: false,
		}).init()
		const swiper2 = new Swiper('.destination_sec1-swiper', {
			slidesPerView: 1,
			spaceBetween: 10,

			pagination: {
				el: '.destination_sec1 .swiper-pagination',
				clickable: true,
			},
		})
	}, [])
	return (
		<>
			<BannerItem
				img={width > 640 ? banner : mobile834}
				title={t('transit.title')}
				color='white'
			/>

			<section className='destination_sec1 wow fadeIn d-f j-c a-c f-c'>
				<div className='container'>
					<div className='titleContainer'>
						<img className='fluid' src={create} />
						&nbsp;{t('transit.title')}{' '}
					</div>
					<div className='title'>{t('transit.title')}</div>
					<div className='desc'></div>

					{width >= 1024 ? (
						<>
							<div
								style={{ justifyContent: 'center' }}
								className='flex-container d-f a-c j-c f-c'
							>
								<div class='card'>
									<div className='img-area'>
										<img
											className='dest fluid card-img-top'
											style={{ marginTop: '-4.375em', marginBottom: 'auto' }}
											src={australia}
										/>
									</div>
									<div class='card-body'>
										<h5 className='card-title'>{t('transit.title1')}</h5>
										<p className='card-text'>{t('transit.desc1')}</p>
									</div>
								</div>

								<div class='card'>
									<div className='img-area d-f j-c'>
										<img
											style={{ marginBottom: 'auto' }}
											className='dest fluid '
											src={europe}
										/>
									</div>
									<div class='card-body'>
										<h5 className='card-title'>{t('transit.title2')}</h5>
										<p className='card-text'>{t('transit.desc2')}</p>
									</div>
								</div>

								<div class='card'>
									<div className='img-area'>
										<img
											style={{ marginTop: '-9.375em' }}
											className='dest fluid  card-img-top'
											src={united}
										/>
									</div>
									<div class='card-body'>
										<h5 className='card-title'>{t('transit.title3')}</h5>
										<p className='card-text'>{t('transit.desc3')}</p>
									</div>
								</div>

								<div class='card'>
									<div className='img-area'>
										<img
											style={{ marginTop: '-5.000em' }}
											className='dest fluid card-img-top'
											src={sabah}
										/>
									</div>
									<div class='card-body'>
										<h5 className='card-title'>{t('transit.title4')}</h5>
										<p className='card-text'>{t('transit.desc4')}</p>
									</div>
								</div>

								<div class='card'>
									<div className='img-area'>
										<img
											style={{ marginTop: '-6.875em' }}
											className='dest fluid card-img-top '
											src={singapore}
										/>
									</div>
									<div class='card-body'>
										<h5 className='card-title'>{t('transit.title5')}</h5>
										<p className='card-text'>{t('transit.desc5')}</p>
									</div>
								</div>
							</div>
						</>
					) : (
						<div className='p-r flex-container d-f j-c a-c f-c'>
							<div className='  swiper3Destination d-f j-c a-c'>
								<div className='destination_sec1-swiper swiper-container'>
									<div className='swiper-wrapper'>
										<div className='swiper-slide'>
											<div class='card'>
												<div className='img-area'>
													<img
														className='dest fluid '
														style={{ marginTop: '-20px', marginBottom: 'auto' }}
														src={australia}
													/>
												</div>
												<div class='card-body'>
													<h5 class='card-title'>{t('transit.title1')}</h5>
													<p className='card-text'>{t('transit.desc1')}</p>
												</div>
											</div>
										</div>
										<div className='swiper-slide'>
											<div class='card'>
												<div className='img-area'>
													<img
														className='dest fluid '
														src={europe}
														style={{ marginTop: 'auto', marginBottom: 'auto' }}
													/>
												</div>
												<div class='card-body'>
													<h5 class='card-title'>{t('transit.title2')}</h5>
													<p className='card-text'>{t('transit.desc2')}</p>
												</div>
											</div>
										</div>
										<div className='swiper-slide'>
											<div class='card'>
												<div className='img-area'>
													<img
														style={{ marginTop: '-40px', marginBottom: 'auto' }}
														className='dest fluid '
														src={sabah}
													/>
												</div>
												<div class='card-body'>
													<h5 class='card-title'>{t('transit.title3')}</h5>
													<p className='card-text'>{t('transit.desc3')}</p>
												</div>
											</div>
										</div>
										<div className='swiper-slide'>
											<div class='card'>
												<div className='img-area'>
													<img
														style={{ marginTop: '-10px', marginBottom: 'auto' }}
														className='dest fluid '
														src={singapore}
													/>
												</div>
												<div class='card-body'>
													<h5 class='card-title'>{t('transit.title4')}</h5>
													<p className='card-text'>{t('transit.desc4')}</p>
												</div>
											</div>
										</div>
										<div className='swiper-slide'>
											<div class='card'>
												<div className='img-area'>
													<img
														style={{ marginTop: '-20px', marginBottom: 'auto' }}
														className='dest fluid  '
														src={singapore}
													/>
												</div>
												<div class='card-body'>
													<h5 class='card-title'>{t('transit.title5')}</h5>
													<p className='card-text'>{t('transit.desc5')}</p>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className='swiper-pagination'></div>
							</div>
						</div>
					)}
				</div>
			</section>
		</>
	)
}

export default Transit
